import React, { useContext, useEffect, useRef } from 'react';
import { Dimensions, StyleSheet, View } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import AppContext, { AppStatus } from '../../contexts/App';
// import RenderHTML from 'react-native-render-html';

/**
 * as of now everything slides from the left to the right @jacksonkr
 * todo: build ReanimateGroupTool(targetRef for convenience, [{left:{start:'0px'}, opacity:{start:0}}]); toolN.withTiming('left', [withTiming params]); @jacksonkr
 */
const SlidingViewContainer = props => {
    const ANIM_DURATION = 750;
    const navContainerViewRef = props.clonedContentRef;
    const { state } = useContext(AppContext);
    const cloneContainerViewRef = useRef(null);
    const animate = props.animate !== undefined ? props.animate : true;

    const navContainerAnimTranslateX = useSharedValue(0);
    const navContainerAnimTranslateY = useSharedValue(0);
    const navContainerAnimOpacity = useSharedValue(100);
    const navContainerAnimStyle = useAnimatedStyle(() => {
        const safeOpacity = animate == false ? navContainerAnimOpacity.value : 100; // todo: revise this; the bug is that the 2nd menu disappears after home > about > bliefs > watch > about > beliefs @jacksonkr
        return {
            opacity: `${safeOpacity}%`,
            transform: `translate(${navContainerAnimTranslateX.value}px, ${navContainerAnimTranslateY.value}px) scaleX(1) scaleY(1)`,
            filter: 'blur(0px)'
        };
    });
    const clonedContainerAnimBlur = useSharedValue(0);
    const clonedContainerAnimOpacity = useSharedValue(100);
    const clonedContainerAnimScaleX = useSharedValue(1);
    const clonedContainerAnimScaleY = useSharedValue(1);
    const clonedContainerAnimTranslateX = useSharedValue(0);
    const clonedContainerAnimTranslateY = useSharedValue(0);
    const clonedContainerAnimStyle = useAnimatedStyle(() => {
        return {
            opacity: `${clonedContainerAnimOpacity.value}%`,
            transform: `translate(${clonedContainerAnimTranslateX.value}px, ${clonedContainerAnimTranslateY.value}px) scaleX(${clonedContainerAnimScaleX.value}) scaleY(${clonedContainerAnimScaleY.value})`,
            filter: `blur(${clonedContainerAnimBlur.value}px)`
        };
    });

    useEffect(() => {
        if (animate) {
            if (state.action.state.status === AppStatus.READY) {
                const navRect = navContainerViewRef && navContainerViewRef.current ? navContainerViewRef.current.getBoundingClientRect() : null;
                if (navRect) {
                    navContainerAnimTranslateX.value = navRect ? 0 - navRect.width : 0;
                    navContainerAnimTranslateX.value = withTiming(0, { duration: ANIM_DURATION });
                    navContainerAnimTranslateY.value = 0;
                    navContainerAnimTranslateY.value = withTiming(0, { duration: ANIM_DURATION });
                    navContainerAnimOpacity.value = 0;
                    navContainerAnimOpacity.value = withTiming(100, { duration: ANIM_DURATION }, isFinished => {
                        if (isFinished) {
                            if (cloneContainerViewRef.current) cloneContainerViewRef.current.style.display = 'none';
                        }
                    });
                }

                const windowHeight = Dimensions.get('window').height;
                const scrollTop = navContainerViewRef.current && navContainerViewRef.current.children[0].scrollTop;
                const contentHeight =
                    (navContainerViewRef.current &&
                        navContainerViewRef.current.children[0].children.length === 1 &&
                        navContainerViewRef.current.children[0].children[0].offsetHeight) ||
                    0;
                const scrollPerc = scrollTop / (contentHeight - windowHeight);
                const adjustedContentHeight = contentHeight - scrollTop + windowHeight * scrollPerc;

                clonedContainerAnimTranslateX.value = 0;
                clonedContainerAnimTranslateX.value = withTiming(20, { duration: ANIM_DURATION });
                clonedContainerAnimTranslateY.value = 0;
                clonedContainerAnimTranslateY.value = withTiming(0 - adjustedContentHeight * 0.02 * (contentHeight / adjustedContentHeight), { duration: ANIM_DURATION });
                clonedContainerAnimOpacity.value = 100;
                clonedContainerAnimOpacity.value = withTiming(0, { duration: ANIM_DURATION });
                clonedContainerAnimScaleX.value = 1;
                clonedContainerAnimScaleX.value = withTiming(1.1, { duration: ANIM_DURATION });
                clonedContainerAnimScaleY.value = 1;
                clonedContainerAnimScaleY.value = withTiming(0.95, { duration: ANIM_DURATION });
                clonedContainerAnimBlur.value = 0;
                clonedContainerAnimBlur.value = withTiming(5, { duration: ANIM_DURATION });
            }
        }
    }, [state.action.href, animate]); // eslint-disable-line react-hooks/exhaustive-deps
    if (cloneContainerViewRef.current && navContainerViewRef.current) {
        // && navContainerViewRef.current.innerHTML) {
        cloneContainerViewRef.current.style.display = ''; // "flex";
        // if(debug = true) cloneContainerViewRef.current.innerHTML = '<div style="position:absolute; height:100%; outline:4px solid red">' + navContainerViewRef.current.innerHTML + '</div>'; else
        // cloneContainerViewRef.current.innerHTML = navContainerViewRef.current.innerHTML;
    }

    /**
     * FOR DEBUG ONLY @jacksonkr
     *
    if(navContainerViewRef.current) {
        const id = 'clone-debug';
        const cloneWrapper = document.querySelector(`#${id}`) || document.createElement('div');
        cloneWrapper.innerHTML = '';
        cloneWrapper.id=id;
        cloneWrapper.style.position='fixed';
        cloneWrapper.style.top='0vh'; 
        cloneWrapper.style.border='12px solid red'; 
        cloneWrapper.style.zoom='0.3'; 
        cloneWrapper.style.zIndex=1001; 
        cloneWrapper.style.pointerEvents='none'; 
        const cloneView = document.createElement('div');
        cloneView.innerHTML=navContainerViewRef.current.innerHTML;
        cloneWrapper.appendChild(cloneView)
        document.body.prepend(cloneWrapper);
    }
    /**/

    const scrollTop = navContainerViewRef.current && navContainerViewRef.current.children ? navContainerViewRef.current.children[0].scrollTop : 0;
    return (
        <View style={{ flex: 1, overflow: 'hidden' }}>
            {animate && (
                <Animated.View
                    ref={cloneContainerViewRef}
                    id={'sliding-view-container-clone'}
                    // style={[props.style, styles.clonedStyleWrapper, clonedContainerAnimStyle]}
                    style={[styles.clonedStyleWrapper, { top: `${0 - scrollTop}px` }, clonedContainerAnimStyle]}
                >
                    {navContainerViewRef.current && navContainerViewRef.current.children && (
                        <div
                            style={{ display: 'flex', flexDirection: 'column', flex: 1 }}
                            dangerouslySetInnerHTML={{ __html: navContainerViewRef.current.children[0].innerHTML }}
                        />
                    )}
                </Animated.View>
            )}
            <Animated.View ref={navContainerViewRef} {...props} style={[props.style, { flex: 1 }, animate && navContainerAnimStyle]} />
        </View>
    );
};

const styles = StyleSheet.create({
    clonedStyleWrapper: {
        position: 'absolute',
        top: 0,
        zIndex: 0,
        minHeight: '100%'
    }
});

export default SlidingViewContainer;
